module.exports = __webpack_public_path__ + "static/media/portugal.a29db759.png";